interface GarageStatusBannerProps {
  status: string;
  blockedAt: string | null;
}

export default function GarageStatusBanner({ status, blockedAt }: GarageStatusBannerProps) {
  // Only surface operational state — DRAFT/PENDING/UPDATE_REQUESTED have their
  // own messaging elsewhere in the partner journey.
  if (status !== 'APPROVED' && status !== 'INACTIVE' && !blockedAt) return null;

  const blocked = !!blockedAt;
  const inactive = !blocked && status === 'INACTIVE';

  const bg = blocked ? '#fde2e2' : inactive ? '#fef3c7' : '#dcfce7';
  const border = blocked ? '#7f1d1d' : inactive ? '#a16207' : '#15803d';
  const fg = blocked ? '#7f1d1d' : inactive ? '#7c4a03' : '#14532d';
  const title = blocked ? 'Blocked' : inactive ? 'Inactive' : 'Active';
  const message = blocked
    ? 'Your garage is blocked by Garagat admin. You will not receive new orders until an admin unblocks you. Please contact support.'
    : inactive
      ? 'You are inactive and will not receive new orders until you switch your status back to active.'
      : 'You are active and accepting new bookings.';

  return (
    <div
      style={{
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: '8px',
        padding: '0.875rem 1rem',
        margin: '0.75rem 0 1rem',
        color: fg,
        display: 'flex',
        gap: '0.75rem',
        alignItems: 'flex-start',
      }}
      role="status"
    >
      <div style={{ fontSize: '0.875rem' }}>
        <strong style={{ display: 'block', marginBottom: '0.125rem' }}>{title}</strong>
        <span>{message}</span>
      </div>
    </div>
  );
}
